import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		refreshInfo: {
			name: '',
			time: ''
		},
		username:'',
		levelOption:[],
		typeOption:[],
		sourceOption:[],
		statusOption:[],
		productTypeOption:[],
		customerStatusOption:[],
	},
	getters: {
		refreshInfo: state => state.refreshInfo,
		levelOption: state => state.levelOption,
		typeOption: state => state.typeOption,
		sourceOption: state => state.sourceOption,
		statusOption: state => state.statusOption,
		productTypeOption: state => state.productTypeOption,
		username: state => state.username,
		customerStatusOption: state => state.customerStatusOption,
	},
	mutations: {
		setRefresh(state,data){
			state.refreshInfo = data
		},
		setLevel(state, data){
			state.levelOption = data
		},
		setType(state, data){
			state.typeOption = data
		},
		setSource(state, data){
			state.sourceOption = data
		},
		setStatus(state, data){
			state.statusOption = data
		},
		setProductType(state, data){
			state.productTypeOption = data
		},
		setUserName(state, data){
			state.username = data
		},
		setCustomerStatus(state, data){
			state.customerStatusOption = data
		},
	}
})

export default store